import { Additional_field } from './additional_field';

export class Entry_type {

	horse_show_id: string;
	number: number;
	name: string;
	description: string;
	closing_date: Date;
	entry_available: boolean;
	enter_wo_horse: boolean;
	invitation_required: boolean;
	payee_required: boolean;
	competition_entry_required: boolean;
	qualification_required: boolean;
	arrival_date_required: boolean;
	billing_message: string;
	notify_stall_count: boolean;
	barn_account: boolean;
	auth_only: boolean;
	declaration_available: boolean;
	allow_competition_entry: boolean = true;
	invitation_description: string;
	hide_section_declarations: boolean;
	hide_competition_declarations: boolean;
	closing_date_for_invited_entries: Date;
	additional_fields_message: string;
	additional_fields: Additional_field[];
	default_competition_number: number;
	collect_entry_fees: boolean;
	auth_full_amount: boolean;
  	other_auth_amount: number;
  	no_skip_payee: boolean;
  	restrict_to_one_rider: boolean;
	restrict_rider_message: string;
	capacity_controlled: boolean;
	discipline: string = 'HJE';
	number_of_horses = 1;
	skip_competition_add: boolean = false;
  stabling_choice_required: boolean = false;
  allow_entry_with_access_code: boolean = false;

	constructor(values: Object = {}) {
		Object.assign(this, values);
	}

}
